import { Component, inject } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { ToastService, Toast } from '../../../core/services/toast.service';

@Component({
    selector: 'app-toast',
    standalone: true,
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.scss',
    animations: [
        trigger('toastAnimation', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateX(100%)' }),
                animate('200ms ease-out', style({ opacity: 1, transform: 'translateX(0)' })),
            ]),
            transition(':leave', [
                animate('150ms ease-in', style({ opacity: 0, transform: 'translateX(100%)' })),
            ]),
        ]),
    ],
})
export class ToastComponent {
    private readonly toastService = inject(ToastService);

    protected readonly toasts = this.toastService.toasts;

    protected dismiss(id: string): void {
        this.toastService.removeById(id);
    }

    protected toastClasses(type: Toast['type']): string {
        const base = 'flex items-start justify-between gap-3 rounded border p-3 text-xs shadow-sm';
        const variants: Record<Toast['type'], string> = {
            success: 'toast-success',
            error: 'bg-red-50 border-red-200 text-red-700',
            warning: 'bg-amber-50 border-amber-300 text-amber-800',
            info: 'toast-info',
        };
        return `${base} ${variants[type]}`;
    }
}
